export default function Awards() {
  return (
    <div>
      <h2 className="heading">Awards</h2>
      <div>
        <div className="subheading">Everywomen in Tech Awards, March 2025 </div>
        <p>
          Recognised as a Rising Star finalist for contributions to technology
          and innovation, highlighting dedication to driving positive change in
          the industry. Acknowledged among inspiring women in tech, reinforcing
          commitment to pushing boundaries and advocating for diversity and
          inclusion within the industry.
        </p>
        <a
          href="https://www.everywoman.com/everywoman-in-technology-awards/finalists/joyce-kadibu/"
          target="blank"
        >
          Find out more - Everywomen in Tech Awards
        </a>
      </div>
      <br />
      <br />
      <div>
        <div className="subheading">
          Imperial College London Awards, July 2023
        </div>
        <p>
          Recognised for steadfast commitment to transforming the student
          lifecycle through delivering a new Customer Relationship Management
          solution. This innovative product streamlines the processing of UCAS
          applications, thereby improving the efficiency and effectiveness of
          admissions procedures at Imperial College London.
        </p>
        <a
          href="https://www.imperial.ac.uk/admin-services/ict/self-service/admin-systems/i360/"
          target="blank"
        >
          Find out more - i360 CRM
        </a>
      </div>
    </div>
  );
}
